<template>
<em class="float-right" style="margin-top: -2px;">
	<a href="javascript:void(0)" :class="current" @click.stop="myAvatar" :data-scp="scp">
		<i class="icon flex-container center" style="float: right;">
			<img :src="avatar" alt="" width="24" height="24" style="vertical-align: baseline;border-radius: 50%;"/>
		</i>
		<span></span>
	</a>
</em>
</template>
<script>
let tempAvatar = ''
	;
export default {
	props: {
		current: ''
		, scp: ''
	}
	, data(){
		return {
			avatar: tempAvatar
		}
	}
	, methods: {
		myAvatar(){

			this.$dispatch('myAvatar');
		}
	}
	, events: {
		setAvatar(avatar){
			tempAvatar = avatar;
			this.avatar=avatar;
		}
	}
}
</script>
<style lang="scss">
.header_right .icon {
    margin-right: 5px;
}
.header_right>a:first-child .icon {
    margin-right: .53333rem;
}
</style>